// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"64f5c511","63":"39bf8ab1","86":"8894a26a","138":"89bb0cb0","160":"5c744345","216":"531166bf","483":"62d42a56","492":"06426b23","541":"42d592e7","634":"a8362227","696":"e71b5ee2","867":"f5756de5","876":"4dea13fb","950":"d49215de"}[chunkId] + ".chunk.js";
};